import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import App from './App.tsx';
import LandingPage from './features/landing/LandingPage.tsx';
import LegalPage from './features/legal/LegalPage.tsx';
import ThemeConfig from './shared/theme/index.tsx';
import { ensureStorageVersion } from './shared/storageVersion.ts';
import './shared/fonts.css';

// Before anything reads a `cg.*` key.
ensureStorageVersion();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeConfig>
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <Routes>
          <Route index element={<LandingPage />} />
          {/* One layout route, so App stays mounted as the scope, the layout and the link change. */}
          <Route element={<App />}>
            <Route path="/explore" element={null} />
            <Route path="/saved" element={null} />
            <Route path="/e/:id" element={null} />
          </Route>
          {/* My Schedule is Saved now (contract §10). */}
          <Route path="/schedule" element={<Navigate to="/saved" replace />} />
          <Route path="/terms" element={<LegalPage document="terms" />} />
          <Route path="/privacy" element={<LegalPage document="privacy" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeConfig>
  </StrictMode>,
);
